<template>
    <section class="tariff-sec">
        <div class="tariff-container">
            <div class="tariff-txt">
                    <h2>{{ title }}</h2>
                    <p>{{ text }}</p><span>برای جزییات بیشتر <router-link to="/tariff">صفحه تعرفه ها</router-link> را بررسی کنید.</span>
            </div>
            <img :src="imageSrc" alt="" class="tariff-img"/>
        </div>
    </section>
</template>

<script>
export default {
    name: "AdTariff",
    props: {
        title: {
          type: String,
          required: true
        },
        text: {
          type: String,
          required: true
        },
        imageSrc: {
          type: String,
          required: true
        },
      },
    setup() {


        return {
        }

    }
};
</script>

<style scoped>
    .tariff-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-inline: 12.37%;
        gap: 18%;
        overflow: hidden;
    }

    .tariff-container img {
        aspect-ratio: 1 / 1;
        width: 36.91%;
        max-width: 400px;
        max-height: 400px;
        object-fit: contain;
        animation: fadeLeft 2s ease-out forwards;

    }

    .tariff-txt  {
        text-align: justify;
    }

    .tariff-txt h2 {
        font-family: 'IRANYekan-Bold';
        font-size: 28px;
        line-height: 38px;
        margin-bottom: 5.295%;
    }

    .tariff-txt p,
    .tariff-txt span,
    .tariff-txt a {
        line-height: 28px;
    }

    .tariff-txt a {
        color: #000000;
    }

@media screen and (min-width: 1441px) {
    .tariff-container {
        width: 1080px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .tariff-container {
        margin-inline: 5.556%;
    }

    .tariff-txt h2 {
        font-size: 24px;
        line-height: 28px;
    }

     .tariff-txt p,
     .tariff-txt span,
     .tariff-txt a {
     line-height: 26px;
     }
}

@media screen and (max-width: 768px) {
    .tariff-container {
        margin-inline: 9.03%;
        flex-direction: column-reverse;
    }

    .tariff-container img {
        width: 258px;
    }

    .tariff-txt h2 {
        margin-bottom: 16px;
    }
}

@media screen and (max-width: 375px) {
    .tariff-txt h2 {
        font-size: 20px;
    }

    .tariff-txt p,
    .tariff-txt span,
    .tariff-txt a {
        font-size: 16px;
    }
}
</style>